import { removeTokens } from '../token';

export const handleAPIErrors = (error, history = []) => {
  const {response} = error;
  if (response && response.status) {
    switch (response.status) {
      case 401:
        removeTokens();
        setTimeout(() => history.push('/login'), 0);
        break;
      default:
        break;
    }
  }
};
